import Link, { LinkProps } from 'next/link'
import React from 'react'
import { SpecialPageType } from '../src/model/fragments'
import { usePageLink } from '../src/hooks/usePageLink'
import { useTranslate } from '../src/hooks/useTranslate'
import { ConditionalWrap } from './ConditionalWrap'

export interface BreadcrumbsProps {
	items: Array<{
		label: string
		linkProps?: LinkProps
	}>

	sideItems?: Array<{
		label: string
		linkProps?: LinkProps
	}>
}

export const Breadcrumbs: React.FunctionComponent<BreadcrumbsProps> = (
	props,
) => {
	const homepageLink = usePageLink(SpecialPageType.index)
	const translate = useTranslate()

	const items = [...props.items]
	const sideItems = [...(props.sideItems ?? [])];

	if (homepageLink) {
		items.unshift({
			linkProps: homepageLink,
			label: translate('breadcrumbs-homepage-label'),
		})
	}
	
	return (
		<nav className="breadcrumbs">
			<div className="breadcrumbs-in">
				{items.map((item, i) => (
					<React.Fragment key={i}>
						<div className="breadcrumbs-item">
							<ConditionalWrap
								condition={Boolean(item.linkProps)}
								wrap={(children) => (
									<Link {...item.linkProps!}>
										<a className="breadcrumbs-link">{children}</a>
									</Link>
								)}
							>
								<>{item.label}</>
							</ConditionalWrap>
						</div>
						{i !== items.length - 1 && (
							<>
								{' '}
								<span className="breadcrumbs-arrow" />{' '}
							</>
						)}
					</React.Fragment>
				))}

				{
					sideItems.length > 0 && <>
						<span className='breadcrumbs-separator'> | </span>
						{
							sideItems.map((item, i) => <React.Fragment key={i + items.length}>
								<div className="breadcrumbs-sideitem">
									<ConditionalWrap
										condition={Boolean(item.linkProps)}
										wrap={(children) => (
											<Link {...item.linkProps!}>
												<a className="breadcrumbs-link">{children}</a>
											</Link>
										)}
									>
										<>{item.label}</>
									</ConditionalWrap>
								</div>
								{i !== sideItems.length - 1 && (
									<>
										{' '}
										<span className="breadcrumbs-arrow" />{' '}
									</>
								)}
							</React.Fragment>)
						}
					</>
				}
			</div>
		</nav>
	)
}
